'use client';

import React from 'react';
import Toaster from 'components/commercetools-ui/atoms/toaster';
import { AccountProvider } from 'context/account';
import AddToCartOverlayProvider from 'context/add-to-cart-overlay';
import { readLocaleCookie } from 'helpers/localeCookie';
import I18nProvider from 'providers/i18n';
import { sdk } from 'sdk';
import { Translations } from 'types/i18n';

// Minimal provider stack for the standalone brand-refresh preview pages: configures the SDK so
// client hooks like useCart() can fetch, supplies translations for formatMessage, and mounts the
// add-to-cart overlay. In the real app these come from the top-level Providers.
//
// `commerce` opts a route into AccountProvider (login + GTM enrichment), which a full commerce surface
// needs. Marketing pages (home, section landings) leave it off to avoid the extra account fetch. The
// react-hot-toast Toaster mounts everywhere: the header's cart drawer is on every page and reports a
// refused cart write through it, which would otherwise be dropped silently.
const BrandRefreshProviders = ({
  translations,
  commerce = false,
  children,
}: React.PropsWithChildren<{ translations: Translations; commerce?: boolean }>) => {
  const locale = readLocaleCookie();
  sdk.defaultConfigure(locale);

  return (
    <I18nProvider translations={translations}>
      <AddToCartOverlayProvider>
        {commerce ? <AccountProvider>{children}</AccountProvider> : children}
        <Toaster />
      </AddToCartOverlayProvider>
    </I18nProvider>
  );
};

export default BrandRefreshProviders;
